<template>
  <div class="row">

    <b-collapse id="ManagerMenu">
      <div class="menu-manager">
        <div class="col-lg-12">
          <div class="row">
            <div v-if="!isMobile()" class="col-lg-12">
             <b-button v-b-toggle.ManagerMenu class="btn-close mr-c float-right"><b-icon icon="x"></b-icon></b-button>
          </div>
            <div class="col-lg-2">
            </div>
          <div class="col-lg-8">
            <div class="row">
              <div class="col-lg-4 text-center">
                <b-button v-b-toggle.ManagerMenu to="/admin/articulo-panel" class="btn-manager">Artículos</b-button>
                <b-button v-b-toggle.ManagerMenu to="/admin/categorias-panel" class="btn-manager">Categorías</b-button>
                <b-button v-b-toggle.ManagerMenu to="/admin/footer-panel" class="btn-manager">Pie de Página</b-button>
                <b-button v-b-toggle.ManagerMenu to="/admin/politicas-panel" class="btn-manager">Políticas</b-button>
                <b-button v-b-toggle.ManagerMenu to="/admin/planes-panel" class="btn-manager">Planes</b-button>
              </div>
            </div>
          </div>
          <div v-if="isMobile()" class="col-lg-12">
             <b-button v-b-toggle.ManagerMenu class="btn-close"><b-icon icon="x"></b-icon></b-button>
          </div>
          </div>
        </div>
        
    </div>
    </b-collapse>

  </div>
</template>

<script>


import postsApi from "../api/posts";

export default {
  name: 'menu-manager',
  components: {
  },
  data() {
    return {
     
    }
  },
  props: {
    msg: String
  },
  
  methods: {
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    }
  },
  mounted () {
  },
}
</script>

<style scoped>
  .menu-manager{
    width: 100%;
    background: #FFFFFF;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    padding-top:8%;
    padding-bottom: 20px;
    z-index: 1029;
   -webkit-box-shadow: 0 0 7px rgba(0, 0, 0, 0.1) !important;
    -moz-box-shadow: 0 0 7px rgba(0, 0, 0, 0.1) !important;
    box-shadow: -2px 0 12px 2px rgba(0, 0, 0, 0.2);
  }
  
  #myBtn {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: red;
    color: white;
    cursor: pointer;
    padding: 15px;
    border-radius: 4px;
  }

  #myBtn:hover {
    background-color: #555;
  }

  /**
  * DIVIDERS
  */
  .divider-01 {
    height: 5px;
    width: 16%;
    background-color: #E8404E;
    border-radius: 3px;
    margin-left: auto;
    margin-right: auto;
  }

  .btn-manager{
    padding: 8px 37px 8px 37px;
    background: #FFFFFF;
    border: 0.5px solid #2DB9D1;
    border-radius: 100px;
    background: #FFFFFF;
    box-shadow: 1px 3px 5px rgba(107, 127, 153, 0.2);
    border-radius: 25px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    align-items: center;
    letter-spacing: 0.1px;
    color:#BDBDBD; 
    margin: 10px;
  }

  .btn-manager.active{
    color: #2DB9D1;
  }

  button.btn-manager:hover{
    color: #2DB9D1;
  }

  .btn-close{
    border: 1px solid #00d0f5;
    border-radius: 100px;
    color:#FFFFFF;
    box-shadow: 1px 3px 5px rgba(107, 127, 153, 0.2);
    border-radius: 25px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    align-items: center;
    letter-spacing: 0.1px;
    transition-duration: 0.3s;  
    background-color: #2DB9D1;
    border-radius: 150px;
    padding: 10px;
    
  }

  .btn-close img{
    width: 40px;
  }

  .mr-c{
    margin-right: 5%;
  }

   button.btn-close:hover{
    background: #00d0f5;
    transition-duration: 0.3s;
  }


  @media(max-width: 768px){
    .menu-manager{
   
    padding-top:20%;
   
  }
    
  }

  @media only screen and(max-width: 30%) {
    #demo {
      display: none;
    }
  }
</style>
